import { hot } from 'react-hot-loader';
import Providers from './Providers';
import AppConfig from './AppConfig';
import AppRouter from './router';



function App() {
  return (
    <Providers>
      <AppConfig />
      <AppRouter />
    </Providers>
  );
};

export default hot(module)(App);
